<template>
    <div class="magicCubeSetting">
        <tab @getTab="getTab"></tab>
        <div id='content' v-if="status === 'content'">
            <div class='headerSerc-item'>
                <span>魔方设置</span>
                <magicCubeConfig :data="setTingObj.magicCube"></magicCubeConfig>
            </div>
        </div>
        <div id='style' v-if="status ==='style'">
            <div class='headerSerc-item'>
                <span>{{setTingObj.bgStyle.title}} ({{setTingObj.bgStyle.list[setTingObj.bgStyle.type].val}})</span>
                <radio :list="setTingObj.bgStyle.list" :type="setTingObj.bgStyle.type" @change="updateBgStyle"></radio>
            </div>
            <div class='headerSerc-item'>
                <span>{{setTingObj.padding.title}}</span>
                <sliderAndInput :lrConfig="setTingObj.padding"></sliderAndInput>
            </div>
            <div class='headerSerc-item'>
                <span>{{setTingObj.lrEdge.title}}</span>
                <sliderAndInput :lrConfig="setTingObj.lrEdge"></sliderAndInput>
            </div>
            <div class='headerSerc-item'>
                <span>{{setTingObj.mbConfig.title}}</span>
                <sliderAndInput :lrConfig="setTingObj.mbConfig"></sliderAndInput>
            </div>
        </div>
    </div>
</template>

<script>
import uploadImage from '@/components/decoration/common/uploadImage.vue';
import radio from '@/components/decoration/common/radio.vue';
import newsConfig from '@/components/decoration/common/newsConfig.vue';
import sliderAndInput from '@/components/decoration/common/sliderAndInput.vue';
import tab from '@/components/decoration/common/tab.vue';
import color from '@/components/decoration/common/color.vue';
import magicCubeConfig from '@/components/decoration/common/magicCubeConfig.vue';

export default {
    components: { color, tab, sliderAndInput, newsConfig, radio, uploadImage, magicCubeConfig },
    data() {
        return{
            status: 'content',
        }
    },
    props:{
        setTingObj: {
            type: Object,
            default: {}
        },
    },
    methods:{
        getTab(e){
            this.status = e
        },
        updateBgStyle(type){
            this.setTingObj.bgStyle.type = type
        },
    }
}
</script>

<style scoped lang="scss">

</style>